import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

const FiltersContext = createContext();

export const FiltersProvider = ({ children }) => {
  const [selectedTagIds, setSelectedTagIds] = useState([]);

  const toggleTag = (tagId) => {
    setSelectedTagIds((prev) => {
      if (!tagId) return prev;
      const exists = prev.includes(tagId);
      if (exists) return prev.filter((t) => t !== tagId);
      return [...prev, tagId];
    });
  };

  const setTags = (tags) => {
    setSelectedTagIds(Array.isArray(tags) ? tags : []);
  };

  const clearTags = () => setSelectedTagIds([]);

  return (
    <FiltersContext.Provider
      value={{ selectedTagIds, toggleTag, setTags, clearTags }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

FiltersProvider.propTypes = { children: PropTypes.node };

export const useFiltersContext = () => {
  const ctx = useContext(FiltersContext);
  if (!ctx) throw new Error("useFiltersContext must be used within FiltersProvider");
  return ctx;
};

export default FiltersProvider;
